/**
 * TZ-robust ISO date parser.
 *
 * SQLite's `datetime('now')` produces bare `YYYY-MM-DD HH:MM:SS` strings
 * without a timezone suffix. Browsers parse these as LOCAL time, which is
 * wrong — they should be treated as UTC.  This helper normalises the string
 * by appending `Z` when no offset/zone marker is present, then validates
 * the result.
 */
export function parseIsoUtc(s: string | null | undefined): Date | null {
  if (!s) return null;
  const normalized = /Z$|[+-]\d{2}:?\d{2}$/.test(s) ? s : s.replace(' ', 'T') + 'Z';
  const d = new Date(normalized);
  return Number.isFinite(d.getTime()) ? d : null;
}

/**
 * Deterministic avatar background for an author id. Resolves to one of the
 * 12 `--avatar-c*` palette tokens so chat messages, DM list, DM conversation
 * header, DM partner card, and member-list avatars all hash the same person
 * to the same colour. Pure string → string; safe to inline into `style="..."`.
 */
export function avatarBg(id: string): string {
  let h = 0;
  for (let i = 0; i < id.length; i++) h = (h * 31 + id.charCodeAt(i)) >>> 0;
  return `var(--avatar-c${(h % 12) + 1})`;
}
